// TODO: Break this file up into the appropriate files. Just creating this so it's easy to share data.
import {RenderConfig} from "draft-js-export-html";

const FONT_METADATA = "FONTMETADATA";
const DEFAULT_FONT_VARIANT_LIGATURES = "none";

enum DraftStyles {
    ITALIC = "ITALIC",
    STRIKETHROUGH  = "STRIKETHROUGH",
    SHADOW = "SHADOW",
    CAPITAL = "CAPITAL",
    SMALLCAPS = "SMALLCAPS",
    UNDERLINE = "UNDERLINE",
    HIGHLIGHT = "HIGHLIGHT",
}

interface InlineStyleTypeItem {
    label: string;
    draftStyle: DraftStyles;
    customStyles: RenderConfig;
    exported: boolean;
}

enum DraftEntityMutability {
    mutable = "MUTABLE",
    immutable = "IMMUTABLE",
    segmented = "SEGMENTED"
}

enum AnchorTarget {
    self = "_self",
    target = "_target"
}

const exportedInlineStyleTypes: Array<InlineStyleTypeItem> = [
    {
        label: "Italics",
        draftStyle: DraftStyles.ITALIC,
        customStyles: {
            element: "span",
            style: {
                fontStyle: "italic",// This appears to be standard across all fonts
            }
        },
        exported: true,
    },
    {
        label: "Line-Through",
        draftStyle: DraftStyles.STRIKETHROUGH,
        customStyles: {
            element: "span",
            style: {
                textDecoration: "line-through",
            }
        },
        exported: true,
    },
    {
        label: "Shadow",
        draftStyle: DraftStyles.SHADOW,
        customStyles: {
            element: "span",
            style: {
                textShadow: "2px 2px 6px rgba(0,0,0,0.5)",
            }
        },
        exported: true,
    },
    {
        label: "Capital",
        draftStyle: DraftStyles.CAPITAL,
        customStyles: {
            element: "span",
            style: {
                textTransform: "uppercase",
            }
        },
        exported: true,
    },
    {
        label: "Small Caps",
        draftStyle: DraftStyles.SMALLCAPS,
        customStyles: {
            element: "span",
            style: {
                fontVariant: "small-caps",
            }
        },
        exported: true,
    },
    {
        label: "Underline",
        draftStyle: DraftStyles.UNDERLINE,
        customStyles: {
            element: "span",
            style: {
                textDecoration: "underline",
            }
        },
        exported: true,
    },
    {
        label: "Highlight",
        draftStyle: DraftStyles.HIGHLIGHT,
        customStyles: {
            element: "span",
            style: {
                background: "#328efe",
                // This rule doesn't work when there is an inline color
                color: "rgb(255,255,255)",
            }
        },
        exported: false,
    }
];

const discardedInlineStyleTypes: Array<InlineStyleTypeItem> = [
    {
        label: "Highlight",
        draftStyle: DraftStyles.HIGHLIGHT,
        customStyles: {
            element: "span",
            style: {
                background: "#328efe",
                // This rule doesn't work when there is an inline color
                color: "rgb(255,255,255)",
            }
        },
        exported: false,
    }
];

const inlineStyleTypes = [
    ...exportedInlineStyleTypes,
    ...discardedInlineStyleTypes,
];

export {
    inlineStyleTypes,
    DraftStyles,
    discardedInlineStyleTypes,
    exportedInlineStyleTypes,
    DraftEntityMutability,
    FONT_METADATA,
    DEFAULT_FONT_VARIANT_LIGATURES,
    AnchorTarget
};



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/textEnhancedWidget/models.ts